import { Badge, Button, Form, Modal, Table } from "react-bootstrap";
import { PaymentCard } from "../../../features/card/cardTypes";
import {
  useDeleteCardMutation,
  useSetDefaultCardMutation,
} from "../../../features/card/cardApi";
import { toast } from "react-toastify";
import { useState } from "react";
import { FaTimes } from "react-icons/fa";



interface CardListProps {
  cardList: PaymentCard[];
}

const PaymentCardList: React.FC<CardListProps> = ({ cardList }) => {
  const [showConfirmation, setShowConfirmation] = useState("");
  const [setDefault] = useSetDefaultCardMutation();
  const [deleteCard] = useDeleteCardMutation();

  const onConfirmation = () => {
    // Handle the confirmation action
    deleteCard({ id: showConfirmation })
      .unwrap()
      .then((res) => {
        setShowConfirmation("");
        toast.success(res?.message ?? "Card deleted successfully");
      })
      .catch((error) => {
        toast.error(error?.data?.message ?? "Error deleting card");
      });
  };

  const handleDefaultCard = (e: React.ChangeEvent<HTMLInputElement>) => {
    const cardId = e.target.id;
    const isChecked = e.target.checked;
    if (isChecked) {
      setDefault({ card_id: cardId })
        .unwrap()
        .then((res) => {
          toast.success(res?.message ?? "Default card set successfully");
        })
        .catch((error) => {
          toast.error(error?.data?.message ?? "Error setting default card");
        });
    }
  };

  return (
    <>
      <Modal
        show={!!showConfirmation}
        onHide={() => setShowConfirmation("")}
        dialogClassName={"modal-dialog-centered"}
      >
        <Modal.Header onHide={() => setShowConfirmation("")} closeButton>
          <h4 className="modal-title">Delete Confirmation</h4>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this saved card?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowConfirmation("")}>
            Cancel
          </Button>{" "}
          <Button variant="primary" onClick={onConfirmation}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Table className="table table-centered table-responsive mb-0 border-0">
        <thead className="table-light rounded sticky-table-header">
          <tr>
            <th>Card</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className="table_body">
          {cardList.map((card) => (
            <tr key={card.card_id}>
              <td>
                {card.brand?.toUpperCase()}{" "}
                <span className="co-name">
                  **** **** **** {card.last_4_digits} ({card.expiry_date})
                </span>
                {card.is_default && (
                  <Badge className="ms-3">Default</Badge>
                )}
              </td>
              <td>
                <div className="flex gap-4 align-items-center">
                  <Form.Check
                    type="switch"
                    className="w-[20px]"
                    id={card.card_id}
                    checked={card.is_default}
                    onChange={handleDefaultCard}
                  />
                  {!card.is_default && (
                    <button
                      style={{ padding: "5px" }}
                      className="btn btn-sm btn-light d-flex align-items-center"
                      onClick={() => setShowConfirmation(card.card_id)}
                    >
                      <FaTimes color={"grey"} fontSize={12} /> Remove
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default PaymentCardList;
